import React from 'react';
import cn from 'classnames';

export const Performance = {
  Max: 'MAX',
  Partial: 'PARTIAL',
  Zero: 'ZERO',
};

const icon = {
  [`${Performance.Max}`]: 'v',
  [`${Performance.Partial}`]: 'c',
  [`${Performance.Zero}`]: 'x',
};

const getSizedIcon = (size) => (size ? `-${size}` : '');

const getIconClass = (performance) => (size) =>
  `${icon[performance]}-mark${getSizedIcon(size)}`;

const PerformanceIcon = ({
  performance,
  size = '',
  score,
  maxScore,
  label,
}) => {
  const getScreenReaderText = (performance) => {
    if (performance === Performance.Max) {
      return 'Correctly answered';
    }
    if (performance === Performance.Zero) {
      return 'Incorrect answer';
    }
    return 'Partially correct answer';
  };
  const forScreenreader = getScreenReaderText(performance);
  return (
    <span className="performance_icon">
      <i className={cn(getIconClass(performance)(size))} aria-hidden="true" />
      <span data-test-performance-icon-score className="label">
        {score}/{maxScore}
      </span>
      <span className="label">{label}</span>
      <span className="sr-only">{forScreenreader}</span>
    </span>
  );
};

export default PerformanceIcon;
